var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconPdf(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_2",
    "data-name": "Layer 2",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 252.43 284.91",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, "\n      .cls-1 {\n        fill: #fff;\n      }\n\n      .cls-1, .cls-2 {\n        fill-rule: evenodd;\n      }\n\n      .cls-2 {\n        fill: #f2623a;\n      }\n\n      .cls-3 {\n        fill: #333;\n      }\n    "))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M43.72,252.13v23.44h115.43v9.34H34.39v-32.78h9.32ZM34.39,0h162.39l55.65,51.37v233.53h-93.29v-9.34h83.97V60.71h-59.32V9.34H43.72v116.32h-9.32V0Z"
  }), /*#__PURE__*/React.createElement("rect", {
    className: "cls-3",
    y: 138.64,
    width: 218.81,
    height: 103.06
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-1",
    d: "M149.93,222.41v-64.49h44.11v10.87h-31.12v15.25h26.82v10.95h-26.82v27.42h-13ZM97.79,168.8v42.77h9.66c6.71,0,11.34-1.45,13.98-4.32,2.64-2.87,3.91-8.57,3.91-17.03,0-6.39-.8-11.03-2.41-14.14-1.58-3.13-3.65-5.05-6.21-5.93-2.56-.88-6.86-1.35-13-1.35h-5.93ZM84.8,157.92h23.79c6.71,0,12.12.88,16.28,2.69,4.22,1.86,7.56,5.39,10.12,10.56,2.56,5.28,3.83,11.75,3.83,19.6,0,21.1-9.89,31.64-29.54,31.64h-24.49v-64.49ZM37.79,168.8v18.3h7.09c5.75,0,9.84-.65,12.22-1.92,2.41-1.29,3.68-3.67,3.68-7.27s-1.11-5.85-3.29-7.12c-2.07-1.37-6.52-2-13.38-2h-6.32ZM24.76,222.41v-64.49h20.84c7.17,0,12.37.31,15.71.88,3.29.62,6.24,2.64,8.88,5.98,2.61,3.29,3.91,7.58,3.91,12.97,0,4.71-.96,8.62-3.03,11.73-2.1,3.21-4.79,5.36-8.08,6.65-3.34,1.27-8.85,1.91-16.75,1.91h-8.46v24.36h-13.02Z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconPdf);
export default __webpack_public_path__ + "static/media/icon_pdf.08f4917e4b873b7d6dc60aa504e728d0.svg";
export { ForwardRef as ReactComponent };